import React from 'react';
import { FormField, FormFieldErrorHelp, FormFieldLabel, FormTextInput } from '@styled/Form';
function TextInput(_a) {
    var label = _a.label, value = _a.value, name = _a.name, onChange = _a.onChange, css = _a.css, placeholder = _a.placeholder, disabled = _a.disabled, bottomMargin = _a.bottomMargin, invalid = _a.invalid, invalidString = _a.invalidString, _b = _a.type, type = _b === void 0 ? 'text' : _b;
    var isInvalid = invalidString && invalidString !== '' ? true : false;
    return (React.createElement(FormField, { style: css, "$bottomSpace": bottomMargin },
        label !== undefined && React.createElement(FormFieldLabel, null, label),
        React.createElement(FormTextInput, { autoComplete: "off", "$invalid": isInvalid || invalid, disabled: disabled, type: type, value: value, name: name, onChange: onChange, placeholder: placeholder }),
        isInvalid && React.createElement(FormFieldErrorHelp, null, invalidString)));
}
export default TextInput;
